import SuccessInfo from './SuccessInfo';

export default SuccessInfo;
